import React from 'react'
import './insideheader.css'

const InsideHeader = ({ pageTitle, pageSubTitle, pageSlug, headerImage }) => (

  <header className="header text-white " style={{backgroundColor: "#78909c", backgroundImage: `url(${headerImage})`}} data-overlay="5">
    <div className="">
      <div className="row">
        <div className="col-md-8 mx-auto">
          <h1 className="underline_bold shadow-7">{pageTitle}</h1>
          <h3 className="shadow-6">{pageSubTitle}</h3>
        </div>
      </div>
    </div>
  </header>

)

export default InsideHeader
